module.exports = __webpack_public_path__ + "img/tbt-23-3-1999_.prt.ef90ea2a.jpg";